// extracted by mini-css-extract-plugin
export var container = "_v4-0";
export var table = "_v4-2";
export var tableWrapper = "_v4-1";